<template>
    <div class="CommandDetail">
        <div class="CommandDetail-title">
            <Breadcrumb>
                <BreadcrumbItem to="/patchManagement/patchCommandParameters">{{$t('PatchEasy.PatchCmd.title')}}</BreadcrumbItem>
                <BreadcrumbItem>{{$t('patch_management.patch_command.commandDetail')}}</BreadcrumbItem>
            </Breadcrumb>
        </div>
        <!-- 命令ID -->
        <Row style="margin-bottom: 20px;">
            <Col span="24">
                <Card >
                    <Row>
                        <Col span="24" class="title">{{$t('PatchEasy.PatchCmd.cmdID')}}</Col>
                    </Row>
                    <Row style="font-size: 13px;">
                        <Col span="24">
                            <Col span="24">{{commandId}}</Col>
                        </Col>
                    </Row>
                </Card>
            </Col>
        </Row>

        <!-- 命令状态 -->
        <Row style="margin-bottom: 20px;">
            <Col span="24">
                <Card >
                    <Row>
                        <Col span="24" class="title">{{$t('PatchEasy.PatchCmd.commandStatus')}}</Col>
                    </Row>
                    <Row>
                        <Col span="24">
                            <Row style="margin-bottom: 16px;">
                                <Col span="24">
                                    <Table :no-data-text="$t('common.noData')" :columns="columnsCommandState" :data="commandState" style="width: 101%;">
                                        <template slot-scope="{row,index}" slot="detail">
                                            <Button type="info" size="small">{{$t('PatchEasy.PatchCmd.viewOutput')}}</Button>
                                        </template>
                                    </Table>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Card>
            </Col>
        </Row>

        <!-- 目标与输出-->
        <Row style="margin-bottom: 20px;">
            <Col span="24">
                <Card >
                    <Row>
                        <Col span="24" class="title">{{$t('PatchEasy.PatchCmd.goalsAndOutputs')}}</Col>
                    </Row>
                    <Row>
                        <Col span="24">
                            <Row style="margin-bottom: 16px;">
                                <Col span="24">
                                    <Input type="text" v-model="ruleName" style="width:40%;margin-bottom: 10px;" :placeholder="$t('PatchEasy.PatchCmd.selectByInstanceID')"></Input>
                                    <Table :no-data-text="$t('common.noData')" :columns="columns" :data="tableTargetInstanceDate" style="width: 101%;">
                                        <template slot-scope="{row,index}" slot="detail">
                                            <Button type="info" size="small" @click="varianceDetail(row)">{{$t('PatchEasy.PatchCmd.viewOutput')}}</Button>
                                        </template>
                                    </Table>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Card>
            </Col>
        </Row>
        <!-- 查看输出 -->
        <Modal v-model="varianceModel" :title="$t('PatchEasy.PatchCmd.output')" :mask-closable="false" width="800px">
            <!-- 步骤 1 - 命令描述和状态 -->
            <Row style="margin-bottom: 20px;">
                <Col span="24">
                    <Row>
                        <Col span="24" class="title">{{$t('PatchEasy.PatchCmd.descriptionAndStatus')}} ({{instanceId}})</Col>
                    </Row>
                    <Row>
                        <Col span="24">
                            <Row style="margin-bottom: 16px;">
                                <Col span="24">
                                    <Table :no-data-text="$t('common.noData')" :columns="viewOutputColumns" :data="viewOutputData" style="width: 100%;"></Table>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Col>
            </Row>
            <!-- 步骤 1 - 输出 -->
            <Row style="margin-bottom: 10px;">
                <Col span="24">
                    <Row>
                        <Col span="24" class="title">{{$t('PatchEasy.PatchCmd.stepOneOutput')}}</Col>
                    </Row>
                    <Row>
                        <Col span="24">{{$t('PatchEasy.PatchCmd.tip')}}</Col>
                    </Row>
                </Col>
            </Row>
            <div slot="footer">
                <Button type="text" size="large" @click="varianceCaseReset">{{ $t('alarms.common.cancel') }}</Button>
            </div>
        </Modal>

        <!-- 名称和描述 -->
        <Row style="margin-bottom: 20px;">
            <Col span="24">
                <Card >
                    <Row>
                        <Col span="24" class="title">{{$t('PatchEasy.PatchCmd.nameAndDescription')}}</Col>
                    </Row>
                    <Row style="font-size: 13px;">
                        <Row :gutter="16">
                            <Col span="14">
                                <Row style="margin-bottom: 20px;">
                                    <Col span="24">{{$t('PatchEasy.PatchCmd.cmdID')}}</Col>
                                    <Col span="24">{{commandId}}</Col>
                                </Row>
                            </Col>
                            <Col span="10">
                                <Row style="margin-bottom: 20px;">
                                    <Col span="24">{{$t('PatchEasy.PatchCmd.commandDocument')}}</Col>
                                    <Col span="24">{{documentName}}</Col>
                                </Row>
                            </Col>
                        </Row>
                        
                        <Row :gutter="16">
                            <Col span="14">
                                <Row style="margin-bottom: 20px;">
                                    <Col span="24">{{$t('PatchEasy.PatchCmd.comment')}}</Col>
                                    <Col span="24">{{comment}}</Col>
                                </Row>
                            </Col>
                            <Col span="10">
                                <Row style="margin-bottom: 20px;">
                                    <Col span="24">{{$t('PatchEasy.PatchCmd.documentVersion')}}</Col>
                                    <Col span="24">{{documentVersion}}</Col>
                                </Row>
                            </Col>
                        </Row>

                        <Row :gutter="16">
                            <Col span="14">
                                <Row style="margin-bottom: 20px;">
                                    <Col span="24">{{$t('PatchEasy.PatchCmd.requestTime')}}</Col>
                                    <Col span="24">{{requestedDateTime}}</Col>
                                </Row>
                            </Col>
                        </Row>
                    </Row>
                </Card>
            </Col>
        </Row>

        <!-- 命令参数 -->
        <Row style="margin-bottom: 20px;">
            <Col span="24">
                <Card >
                    <Row>
                        <Col span="24" class="title">{{$t('PatchEasy.PatchCmd.commandParameters')}}</Col>
                    </Row>
                    <Row style="font-size: 13px;">
                        <Row :gutter="16">
                            <Col span="14">
                                <Row style="margin-bottom: 10px;">
                                    <Col span="24">{{$t('PatchEasy.PatchCmd.parameter')}}</Col>
                                </Row>
                                <Row style="margin-bottom: 10px;">
                                    <Col span="12">allowDowngrade</Col>
                                    <Col span="12">{{allowDowngrade}}</Col>
                                </Row>
                                <Row style="margin-bottom: 10px;">
                                    <Col span="12">version</Col>
                                    <Col span="12">{{version}}</Col>
                                </Row>
                            </Col>
                            <Col span="10">
                                <Row style="margin-bottom: 20px;">
                                    <Col span="24">{{$t('PatchEasy.PatchCmd.deliveryTimeout')}}</Col>
                                    <Col span="24"></Col>
                                </Row>
                                <Row style="margin-bottom: 20px;">
                                    <Col span="24">{{$t('PatchEasy.PatchCmd.executionTimeout')}}</Col>
                                    <Col span="24"></Col>
                                </Row>
                            </Col>
                        </Row>
                    </Row>
                </Card>
            </Col>
        </Row>
    </div>
</template>

<script>
    export default {
        name: 'commandDetail',
        data(){
            return {
                accountIdSearchKey:'',
                regionSearchKey:'',
                instanceId:'',
                commandId:'',
                commandState:'',
                documentName:'',
                comment:'',
                documentVersion:'',
                requestedDateTime:'',
                allowDowngrade:'',
                version:'',
                commandParametersDTO:[],
                ruleName:'',
                varianceModel:false, //输出详情
                isSpecifyLabel:false,
                isManualSelectionInstance:false, //目标
                isS3: false,
                isCloudwatch: false, //输出选项
                columns: [
                    {
                        title: this.$t('PatchEasy.PatchCmd.instanceID'),
                        key: 'instanceId'
                    },
                    {
                        title: this.$t('PatchEasy.PatchCmd.instanceName'),
                        key: 'instanceName'
                    }, 
                    {
                        title: this.$t('alarms.common.status'),
                        key: 'status'
                    },
                    {
                        title: this.$t('PatchEasy.PatchCmd.backupID'),
                        key: 'backupId'
                    },
                    {
                        title: this.$t('PatchEasy.PatchCmd.startTime'),
                        key: 'startTime'
                    },
                    {
                        title: this.$t('PatchEasy.PatchCmd.completeTime'),
                        key: 'finishTim'
                    },
                    {
                        title: this.$t('common.operation'),
                        slot: 'detail'
                    }
                ],
                columnsCommandState: [
                    {
                        title: this.$t('PatchEasy.PatchCmd.overallStatus'),
                        key: 'status'
                    },
                    {
                        title: this.$t('PatchEasy.PatchCmd.detailedStatus'),
                        key: 'statusDetails'
                    }, 
                    {
                        title: this.$t('PatchEasy.PatchCmd.tgt'),
                        key: 'targetCount'
                    },
                    {
                        title: this.$t('PatchEasy.PatchCmd.complete'),
                        key: 'completedCount'
                    },
                    {
                        title: this.$t('PatchEasy.PatchCmd.error'),
                        key: 'errorCount'
                    },
                    {
                        title: this.$t('PatchEasy.PatchCmd.submitDelay'),
                        key: 'deliveryTimedOutCount'
                    }
                ],
                viewOutputColumns:[
                    {
                        title: this.$t('alarms.common.status'),
                        key: 'status'
                    },
                    {
                        title: this.$t('PatchEasy.PatchCmd.detailedStatus'),
                        key: 'statusDetails'
                    }, 
                    {
                        title: this.$t('PatchEasy.PatchCmd.responseCode'),
                        key: 'responseCode'
                    },
                    {
                        title: this.$t('PatchEasy.PatchCmd.stepName'),
                        key: 'stepName'
                    },
                    {
                        title: this.$t('PatchEasy.PatchCmd.startTime'),
                        key: 'startTime'
                    },
                    {
                        title: this.$t('PatchEasy.PatchCmd.completeTime'),
                        key: 'finishTime'
                    }
                ],
                viewOutputData:[],
                tableTargetInstanceDate:[],
                commandState:[]
            }
        },
        mounted () {
            this.init();
        },
        methods: {
            /******************查看输出详情*******************************************************/ 
            init () {
                // 命令ID
                this.commandId=this.$route.query.commandId;
                // 命令状态
                this.commandState=this.$route.query.commandStatusDTOs;
                // 目标与输出
                this.tableTargetInstanceDate=this.$route.query.commandTargetsAndOutputsDTOs;
                // 命令文档
                this.documentName=this.$route.query.documentName;
                // 注释
                this.comment=this.$route.query.comment;
                // 文档版本
                this.documentVersion=this.$route.query.documentVersion;
                // 请求时间
                this.requestedDateTime=this.$route.query.requestedDateTime;
                // 参数
                this.commandParametersDTO=this.$route.query.commandParametersDTO;
                this.allowDowngrade=this.$route.query.allowDowngrade;
                this.version=this.$route.query.version;
                this.accountIdSearchKey=this.$route.query.accountIdSearchKey;
                this.regionSearchKey=this.$route.query.regionSearchKey;
            },
            // 详情
            varianceDetail:function(row){
                this.instanceId=row.instanceId;
                this.varianceModel=true;
                //分页
                this.$api.policy.getCommandTargetInstanceOutput({
                    "awssmCommandRequestDTO" : {
                        "commandId" :  this.commandId,
                        "instanceId" : row.instanceId,
                        "deatils" : true
                    },
                    "accountId" : this.accountIdSearchKey,
                    "regionString" : this.regionSearchKey             
                })
                .then(res => {
                    this.viewOutputData=res.data.commandDescriptionAndStatusDTOS;
                });
            },
             // 取消
            varianceCaseReset:function(){
                this.varianceModel=false;
            }
        }
        
    }
</script>

<style scoped>
    .CommandDetail-title
    {
        width: 100%;
        font-size: 13px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        padding: 15px 0px 8px 4px;
        font-weight: 600;
    }
    .ivu-breadcrumb {
        font-size: 13px;
        font-weight: 600;
        color: #515a6e;
    }
    .title
    {
        font-size:14px;
        font-weight: 600;
        float:left;
        color:#000;
        margin-bottom: 30px;
    }

</style>



// WEBPACK FOOTER //
// src/components/patch_management/patch_command_parameters/CommandDetail.vue